import React from 'react';
import { observer } from 'mobx-react';

type PropsType = {
    template?: React.ReactNode;
    render: React.ReactNode
};

export const UiSlot = observer(function UiSlot({
    template,
    render
}: PropsType) {
    return (<>{template || render}</>);
});
